import React, { Component } from "react";
import QuoteBlinds from "./QuoteBlinds/ProjectQuoteBlinds";
import QuoteCurtains from "./QuoteCurtains/QuoteCurtains";
import { MDBTabPane, MDBTabContent, MDBNav, MDBNavItem, MDBNavLink, MDBBtn } from "mdbreact";
import { connect } from "react-redux";
import PopUpForm from "../../../../Generic/PopUpDialog/PopUpForm";
import { toggleDiscountView } from "../../../../../actions/documentsActions";

class QuoteWrapper extends Component {
  constructor(props) {
    super(props);
    this.state = {
      retail: this.props.match.params[0] === "wholesale-quote" ? false : true,
      items: {
        default: "blinds",
      },
      optionsPopUp: false,
      options: {
        billofRates: false,
        scheduleofItems: true,
        grouping: "job",
        sorting: "default",
        itemNotes: false,
        showDiscounts: false,
      },
    };
  }

  getValidationTypes = () => {
    return [
      {
        id: "billofRates",
        label: "Show Bill of Rates?",
        type: "select",
        options: [
          { value: true, name: "Yes" },
          { value: false, name: "No" },
        ],
        required: true,
        value: this.state.options.billofRates.toString(),
      },
      {
        id: "scheduleofItems",
        label: "Show Schedule of Items?",
        type: "select",
        options: [
          { value: true, name: "Yes" },
          { value: false, name: "No" },
        ],
        required: true,
        value: this.state.options.scheduleofItems.toString(),
      },
      {
        id: "itemNotes",
        label: "Show Item Notes?",
        type: "select",
        options: [
          { value: true, name: "Yes" },
          { value: false, name: "No" },
        ],
        required: true,
        value: this.state.options.itemNotes.toString(),
      },
      {
        id: "grouping",
        label: "Group Items By?",
        type: "select",
        options: [
          { value: "job", name: "Job Name (Default)" },
          { value: "location", name: "Location" },
          { value: "productCode", name: "Product Code" },
          { value: "driveType", name: "Drive Mechanism Type" },
          { value: "style", name: "Style Name" },
          { value: "fabric", name: "Fabric Name" },
          { value: "fabricAndColour", name: "Fabric + Colour" },
          { value: "driveMechanism", name: "Drive Mechanism Name" },
        ],
        required: true,
        value: this.state.options.grouping.toString(),
      },
      {
        id: "sorting",
        label: "Sort Items By?",
        type: "select",
        options: [
          { value: "default", name: "Default (Job Number)" },
          { value: "alphabetical", name: "Alphabetical" },
        ],
        required: true,
        value: this.state.options.sorting.toString(),
      },
      {
        id: "showDiscounts",
        label: "Show Discounts on Quote?",
        type: "select",
        options: [
          { value: true, name: "Yes" },
          { value: false, name: "No" },
        ],
        required: true,
        value: this.state.options.showDiscounts.toString(),
      },
    ];
  };

  handleOptionsPopUp = (formData) => {
    this.setState({
      options: {
        ...this.state.options,
        billofRates: formData.billofRates === "true",
        scheduleofItems: formData.scheduleofItems === "true",
        itemNotes: formData.itemNotes === "true",
        grouping: formData.grouping,
        sorting: formData.sorting,
        showDiscounts: formData.showDiscounts === "true",
      },
      optionsPopUp: false,
    });
  };

  togglePills = (type, tab) => (e) => {
    e.preventDefault();
    if (this.state.items[type] !== tab) {
      let items = { ...this.state.items };
      items[type] = tab;
      this.setState({
        items,
      });
    }
  };

  render() {
    return (
      <div className="quote-wrapper">
        {this.state.optionsPopUp ? (
          <PopUpForm
            fields={this.getValidationTypes()}
            apiMethod={this.handleOptionsPopUp}
            header="Quote Options"
            button="Accept"
            buttoncolour="green"
            button2="Cancel"
            button2colour="red"
            button2ClickHandler={() => this.setState({ optionsPopUp: false })}
          />
        ) : (
          ""
        )}
        <MDBNav className="nav-pills fluid align-middle d-flex justify-content-center">
          <MDBNavItem>
            <MDBNavLink
              to="#"
              active={this.state.items["default"] === "blinds"}
              onClick={this.togglePills("default", "blinds")}
            >
              Blinds
            </MDBNavLink>
          </MDBNavItem>
          <MDBNavItem>
            <MDBNavLink
              to="#"
              active={this.state.items["default"] === "curtains"}
              onClick={this.togglePills("default", "curtains")}
            >
              Curtains
            </MDBNavLink>
          </MDBNavItem>
        </MDBNav>
        <MDBBtn
          color="blue"
          id="quoteDiscountButtonProj"
          onClick={() => this.props.dispatch(toggleDiscountView(true))}
        >
          Discounts
        </MDBBtn>
        <MDBBtn
          color="grey"
          id="quoteOptionsButtonProj"
          onClick={() => this.setState({ optionsPopUp: true })}
        >
          Options
        </MDBBtn>
        <MDBBtn color="green" id="quoteExportButtonProj" onClick={() => window.print()}>
          Export
        </MDBBtn>
        <MDBTabContent activeItem={this.state.items["default"]}>
          <MDBTabPane tabId="blinds">
            <QuoteBlinds
              projectId={this.props.match.params.id}
              projectType={this.props.sideList.selectedTabText}
              projectDetails={this.props.projectDetails}
              isRetail={this.props.match.params[0] === "retail-quote"}
              docNumber={this.props.docNumber}
              options={this.state.options}
            />
          </MDBTabPane>
          <MDBTabPane tabId="curtains">
            <QuoteCurtains
              isRetail={this.props.match.params[0] === "retail-quote"}
              docNumber={this.props.docNumber}
              options={this.state.options}
            />
          </MDBTabPane>
        </MDBTabContent>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return { ...state.projects };
};

export default connect(mapStateToProps)(QuoteWrapper);
